import { fetchClients, deleteClient, restoreClient } from '../../../api/adminApi';
import { t, createScreenHeader, createBackButton, isUnauthorized, openConfirmModal } from './context';
export function showClientsScreen(ctx) {
    ctx.screen.innerHTML = '';
    const header = createScreenHeader(t('admin.clients.title'));
    const content = document.createElement('div');
    content.className = 'admin__content';
    content.textContent = t('admin.clients.loading');
    const backButton = createBackButton(ctx, t('admin.clients.back'));
    ctx.screen.append(header, content, backButton);
    loadClients(ctx, content, false);
}
function loadClients(ctx, content, showingDeleted) {
    content.innerHTML = '';
    content.textContent = t('admin.clients.loading');
    fetchClients(showingDeleted)
        .then((clients) => {
        renderClientsContent(ctx, content, clients, showingDeleted);
    })
        .catch((err) => {
        if (isUnauthorized(err)) {
            ctx.showLogin();
            return;
        }
        console.error('Failed to load clients:', err);
        content.textContent = t('admin.clients.loadError');
    });
}
function renderClientsContent(ctx, content, clients, showingDeleted) {
    content.innerHTML = '';
    if (clients.length === 0) {
        const empty = document.createElement('p');
        empty.className = 'admin__table-empty';
        empty.textContent = showingDeleted ? t('admin.clients.emptyDeleted') : t('admin.clients.empty');
        content.appendChild(empty);
    }
    else {
        const table = document.createElement('table');
        table.className = 'admin__table';
        const thead = document.createElement('thead');
        const headRow = document.createElement('tr');
        const headLabels = [t('admin.clients.table.name'), t('admin.clients.table.phone'), t('admin.clients.table.email')];
        if (!showingDeleted)
            headLabels.push('');
        for (const label of headLabels) {
            const th = document.createElement('th');
            th.textContent = label;
            headRow.appendChild(th);
        }
        thead.appendChild(headRow);
        table.appendChild(thead);
        const tbody = document.createElement('tbody');
        for (const client of clients) {
            const row = document.createElement('tr');
            const nameCell = document.createElement('td');
            if (showingDeleted) {
                // Deleted rows have no action column — clicking the name itself is
                // the undelete entry point instead.
                const nameButton = document.createElement('button');
                nameButton.type = 'button';
                nameButton.className = 'admin__table-edit';
                nameButton.textContent = `${client.surname} ${client.name}`;
                nameButton.addEventListener('click', () => {
                    openRestoreConfirm(ctx, client, () => loadClients(ctx, content, showingDeleted));
                });
                nameCell.appendChild(nameButton);
            }
            else {
                nameCell.textContent = `${client.surname} ${client.name}`;
            }
            const phoneCell = document.createElement('td');
            phoneCell.textContent = client.phone ?? '—';
            const emailCell = document.createElement('td');
            emailCell.textContent = client.email;
            row.append(nameCell, phoneCell, emailCell);
            if (!showingDeleted) {
                const actionCell = document.createElement('td');
                const deleteButton = document.createElement('button');
                deleteButton.type = 'button';
                deleteButton.className = 'admin__table-edit';
                deleteButton.textContent = t('admin.clients.deleteButton');
                deleteButton.addEventListener('click', () => {
                    openDeleteConfirm(ctx, client, () => loadClients(ctx, content, showingDeleted));
                });
                actionCell.appendChild(deleteButton);
                row.appendChild(actionCell);
            }
            tbody.appendChild(row);
        }
        table.appendChild(tbody);
        content.appendChild(table);
    }
    const toggleButton = document.createElement('button');
    toggleButton.type = 'button';
    toggleButton.className = 'cta admin__submit';
    toggleButton.textContent = showingDeleted ? t('admin.clients.showActiveButton') : t('admin.clients.showDeletedButton');
    toggleButton.addEventListener('click', () => loadClients(ctx, content, !showingDeleted));
    content.appendChild(toggleButton);
}
function openDeleteConfirm(ctx, client, onDeleted) {
    openConfirmModal(ctx, {
        text: t('admin.clients.deleteConfirm.text', { name: `${client.surname} ${client.name}` }),
        noLabel: t('admin.clients.deleteConfirm.no'),
        yesLabel: t('admin.clients.deleteConfirm.yes'),
        yesClassName: 'cta admin__delete',
        errorText: t('admin.clients.deleteConfirm.error'),
        logMessage: 'Failed to delete client:',
        action: () => deleteClient(client.id),
        onDone: onDeleted,
    });
}
function openRestoreConfirm(ctx, client, onRestored) {
    openConfirmModal(ctx, {
        text: t('admin.clients.restoreConfirm.text', { name: `${client.surname} ${client.name}` }),
        noLabel: t('admin.clients.restoreConfirm.no'),
        yesLabel: t('admin.clients.restoreConfirm.yes'),
        yesClassName: 'cta admin__submit',
        errorText: t('admin.clients.restoreConfirm.error'),
        logMessage: 'Failed to restore client:',
        action: () => restoreClient(client.id),
        onDone: onRestored,
    });
}
